import { Box } from '@mui/material';
import {
  DataGridPro,
  GridColDef,
  GridRowOrderChangeParams,
  GridRowsProp,
} from '@mui/x-data-grid-pro';
import { useCallback, useMemo } from 'react';

import {
  ActionCellRenderer,
  DefaultValueCellRenderer,
  NameCellRenderer,
  TypeCellRenderer,
} from './ParameterCellRenderer';
import { selectParameterDefinitions } from '../../../features/workflow/selectors';
import { setParameterDefinitions } from '../../../features/workflow/workflowSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export const ParametersList = () => {
  const parameters = useAppSelector(selectParameterDefinitions);
  const dispatch = useAppDispatch();

  const rows: GridRowsProp = useMemo(
    () =>
      parameters.map((parameter) => ({
        ...parameter,
        __reorder__: parameter.type,
      })),
    [parameters]
  );

  const columns: GridColDef[] = [
    {
      field: 'type',
      headerName: 'Type',
      width: 150,
      renderCell: TypeCellRenderer,
    },
    {
      field: 'name',
      flex: 1,
      headerName: 'Name',
      renderCell: NameCellRenderer,
    },
    {
      field: 'default',
      flex: 1,
      headerName: 'Default value',
      renderCell: DefaultValueCellRenderer,
    },
    {
      field: 'delete',
      headerName: '',
      renderCell: ActionCellRenderer,
    },
  ];

  const handleRowOrderChange = useCallback(
    ({ oldIndex, targetIndex }: GridRowOrderChangeParams) => {
      const parameter = parameters[oldIndex];
      if (!parameter) return;

      const newParameters = [...parameters];
      newParameters.splice(oldIndex, 1);
      newParameters.splice(targetIndex, 0, parameter);

      dispatch(setParameterDefinitions(newParameters));
    },
    [parameters, dispatch]
  );

  return (
    <Box height={600} marginTop={3}>
      <DataGridPro
        columnHeaderHeight={28}
        columns={columns}
        disableColumnSorting={true}
        disableColumnMenu={true}
        hideFooter={true}
        rowReordering
        rows={rows}
        rowSelection={false}
        onRowOrderChange={handleRowOrderChange}
      />
    </Box>
  );
};
